const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// Global hook so AuthContext can react when the backend tells us the
// current user has been deactivated mid-session.
let onAccountDeactivated = null;
export function setAccountDeactivatedHandler(fn) {
  onAccountDeactivated = fn;
}

async function apiFetch(path, options = {}) {
  let res;
  try {
    res = await fetch(BASE + path, {
      credentials: "include",
      headers: { "Content-Type": "application/json", ...options.headers },
      ...options,
    });
  } catch (networkErr) {
    const err = new Error(
      "Something went wrong. Please check your connection and try again."
    );
    err.status = 0;
    throw err;
  }

  if (res.status === 401) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data.error || "Authentication required");
    err.status = 401;
    throw err;
  }

  const data = await res.json().catch(() => ({}));

  // Global handling for "account deactivated" — this can arrive on any
  // endpoint (not just /auth/me) because auth_required checks the flag
  // on every authenticated request.
  if (res.status === 403 && data.error === "account_deactivated") {
    if (onAccountDeactivated) onAccountDeactivated(data.message);
    const err = new Error(data.message || "Account deactivated");
    err.status = 403;
    err.code = "account_deactivated";
    throw err;
  }

  if (!res.ok) {
    const err = new Error(data.error || "Request failed");
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  get: (path) => apiFetch(path),
  post: (path, body) =>
    apiFetch(path, { method: "POST", body: JSON.stringify(body) }),
  put: (path, body) =>
    apiFetch(path, { method: "PUT", body: JSON.stringify(body) }),
  delete: (path) => apiFetch(path, { method: "DELETE" }),
};

export const API_BASE = BASE.replace(/\/api\/?$/, "");
